/**
 * 救援服务单一览
 * 创建时间：2017-07-21
 * 创建人：zhanlz
 * 修改人：sun shujuan
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="rescueserviceorder-list">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">救援单号</label>
				<div class="col-sm-2" v-bind:class="{'form-group--error': $v.queryParam.id.$error }">
					<input class="form-control" v-model.trim="queryParam.id" @input="$v.queryParam.id.$touch()" maxlength="10"/>
					<span class="cus_message form-group__message" v-if="!$v.queryParam.id.maxLength && $v.queryParam.id.$error">救援单号不能超过5位数</span>
				</div>
				<label class="col-sm-1 control-label">服务状态</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.rescueStatus">
						<option v-for="(option, index) in rescueStatusList" v-bind:value="option.udccode" :key="'rescuestatus' + index">
							{{ option.udcname}}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">服务阶段</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.rescueStage">
						<option v-for="(option, index) in rescueStageList" v-bind:value="option.udccode"  :key="'rescueStage' + index">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">救援类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.rescueType">
						<option v-for="(option, index) in rescueTypeList" v-bind:value="option.udccode" :key="'rescueType' + index">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">客户电话</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.rescuedPhone">
				</div>
				<label class="col-sm-1 control-label">被救援车牌</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.rescuedPlateNumber">
				</div>
				<!--<label class="col-sm-1 control-label">救援请求时间</label>
				<div class="col-sm-2">
					<div class="col-sm-5" v-bind:class="{ 'form-group--error': validDates }">
						<datepicker v-model="queryParam.requestStartTime" class="form-control" ref="startTime"></datepicker>
					</div>
					<label class="col-sm-1 control-label t_center">-</label>
					<div class="col-sm-5" v-bind:class="{ 'form-group--error': validDates }">
						<datepicker v-model="queryParam.requestEndTime" class="form-control" ref="endTime"></datepicker>
					</div>
					<p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>-->
				<label class="col-sm-1 control-label">请求开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
					<datepicker v-model="queryParam.requestStartTime" class="form-control" ref="startTime"></datepicker>
					<p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">请求结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
					<datepicker v-model="queryParam.requestEndTime" class="form-control" ref="endTime"></datepicker>
					<p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">时间类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model.trim="queryParam.dateType">
						<option :value="dateType.udccode" v-for="(dateType, index) in dateTypeList" :key="'dataType' + index">{{dateType.udcname}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">救援公司</label>
				<div class="col-sm-2">
					<!-- <select class="form-control" v-model.trim="queryParam.customerName">
						<option v-for="corp in rescueCompanies" :value="corp.groupName">{{corp.groupName}}</option>
					</select> -->
					<multi-select-tree
						ref="zTree"
						:setting="setting"
						url="/rescue-api/account/customer/fleet"
						v-model="selectCompanysArr"
						v-on:onerror="handleError"
					></multi-select-tree>
					<!--<input class="form-control" v-model.trim="queryParam.customerName">-->
				</div>
				<label class="col-sm-1 control-label">救援车牌</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.plateNumber">
				</div>
				<label class="col-sm-1 control-label">结算费用区间</label>
				<div class="col-sm-2" >
					<div class="col-sm-5" v-bind:class="{ 'form-group--error': validCost }">
						<input v-model="queryParam.closingCostStart" class="form-control" ref="startCost" />
					</div>
					<label class="col-sm-1 control-label t_center">-</label>
					<div class="col-sm-5" v-bind:class="{ 'form-group--error': validCost }">
						<input v-model="queryParam.closingCostEnd" class="form-control" ref="endCost" />
					</div>
					<p v-if="validCost" class="cus_message form-group__message">请输入正确的费用区间</p>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">服务超时类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.timeOutStatus" >
						<option :value="timeoutStage.udccode" v-for="(timeoutStage, index) in timeoutStageList" :key="'timeout' + index">{{timeoutStage.udcname}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label" v-if="levv!=3">客户评价</label>
				<div class="col-sm-2" v-if="levv!=3">
					<select class="form-control" v-model="queryParam.evaluateStatus" >
						<option value="" >全部</option>
						<option value="1" >好评</option>
						<option value="2" >中评</option>
						<option value="3" >差评</option>
						<option value="4" >暂无</option>
					</select>
				</div>
				<label class="col-sm-1 control-label" v-if="levv!=3">客服评价</label>
				<div class="col-sm-2" v-if="levv!=3">
					<select class="form-control" v-model="queryParam.customerServiceEvaluateStatus" >
						<option value="" >全部</option>
						<option value="1" >好评</option>
						<option value="2" >中评</option>
						<option value="3" >差评</option>
						<option value="4" >暂无</option>
					</select>
				</div>
        <label class="col-sm-1 control-label" v-if="levv!=3">服务单来源</label>
				<div class="col-sm-2" v-if="levv!=3">
					<select class="form-control" v-model="queryParam.certificatesType" >
						<option value="" >全部</option>
						<option value="1" >电话</option>
						<option value="2" >微信</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">保单号</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.policyNo">
				</div>	
        		<label class="col-sm-1 control-label">救援公司审核</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.companyAuditStatus" >
						<option value="" >全部</option>
						<option value="1" >已提交</option>
						<option value="0" >待提交</option>
					</select>
				</div>
        		<label class="col-sm-1 control-label">人保审核</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.piccAuditStatus" >
						<option value="" >全部</option>
						<option value="1" >通过</option>
						<option value="2" >不通过</option>
						<option value="0" >待审核</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">总部审核</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.platformAuditStatus" >
						<option value="" >全部</option>
						<option value="1" >通过</option>
						<option value="2" >审核失败</option>
						<option value="3" >已结算</option>
						<option value="0" >待审核</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">空驶状态</label>
				<div class="col-sm-2">
					<select class="form-control"  v-model="queryParam.fallEmpty">
						<option value="" >全部</option>
						<option value="1" >是</option>
						<option value="0" >否</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button"  class="btn btn-primary" @click="searchInfo" :disabled="validDates || validCost" v-if="permission.indexOf('rescueServiceOrderList_select') == -1">查询</button>
					<button type="button"  class="btn btn-primary" @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" v-if="permission.indexOf('rescueServiceOrderList_insert') == -1"  class="btn btn-primary" @click="createNewOrder" >新建救援服务单</button>
					<button type="button" v-if="permission.indexOf('rescueServiceOrderList_export') == -1"  class="btn btn-primary" @click="exportOrder">导出</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<!--表格开始-->
		<div class="table-responsive">
			<div style="overflow:auto;">
				<table class="table table-striped table-bordered" style="min-width:2000px;">
					<thead>
						<tr>
							<th rowspan="2">救援单号</th>
							<th rowspan="2">请求时间</th>
							<th class="text-center" colspan="3">救援进度</th>
							<th rowspan="2">救援类型</th>
							<th rowspan="2">服务单来源</th>
							<th class="text-center" colspan="5">被救援信息</th>
							<th class="text-center" colspan="3">救援信息</th>
							<th class="text-center" colspan="2" v-if="levv!=3">评价信息</th>
							<th colspan="2"  class="text-center">总部审核</th>
							<th colspan="2"  class="text-center">救援公司审核</th>
							<th colspan="2"  class="text-center">人保审核</th>
							<th rowspan="2">结算费用</th>
							<th rowspan="2"></th>
						</tr>
						<tr>
							<th>状态</th>
							<th>阶段</th>
							<th>时间</th>
							<th>车牌号</th>
							<th>车型</th>
							<th>颜色</th>
							<th>电话</th>
							<th>救援地址</th>
							<th>救援公司</th>
							<th>救援车牌</th>
							<th>接单时间</th>
							<th v-if="levv!=3" width=50>客户</th>
							<th v-if="levv!=3" width=50>客服</th>
							<th>状态</th>
							<th>审核时间</th>
							<th>状态</th>
							<th>提交时间</th>
							<th>状态</th>
							<th>审核时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(fileInfo,index) in orderList" v-bind:key="index">
							<td>RS{{fileInfo.id}}</td>
							<td>{{fileInfo.dateType==1?'(预)' + fileInfo.requestTimeNote : fileInfo.requestTimeNote}}</td>
							<td>{{fileInfo.rescueStatusName}}</td>
							<td>{{fileInfo.rescueStageName}}</td>
							<td>{{fileInfo.rescueStageTimeNote}}</td>
							<td>{{fileInfo.rescueTypeName}}</td>
              				<td>{{fileInfo.certificatesTypeString}}</td>
							<td>{{fileInfo.rescuedPlateNumber}}</td>
							<td>{{fileInfo.rescuedModel}}</td>
							<td>{{fileInfo.rescuedColor}}</td>
							<td>{{fileInfo.rescuedPhone}}</td>
							<td>{{fileInfo.rescuedAddress}}</td>
							<td>{{fileInfo.customerName}}</td>
							<td>{{fileInfo.plateNumber}}</td>
							<td>{{fileInfo.orderTimeNote}}</td>							
							<td v-if="levv!=3">{{fileInfo.evaluateStatusName}}</td>
							<td v-if="levv!=3">{{fileInfo.customerServiceEvaluateStatusName}}</td>
							<th>{{fileInfo.platformAuditStatusStr}}</th>
							<th>{{fileInfo.platformAuditTime}}</th>
							<td>{{fileInfo.companyAuditStatusString}}</td>
							<td>{{fileInfo.companyAuditTime}}</td>
							<td>{{fileInfo.piccAuditStatusString}}</td>
							<td>{{fileInfo.piccAuditTime}}</td>
							<td class="list">￥{{fileInfo.closingCost}}</td>
							<td class="text-center">
								<a @click="handle(fileInfo.id)" v-if="permission.indexOf('rescueServiceOrderList_detail') == -1">详情&nbsp;</a>
								<!--如果当前操作员为“救援公司”，则已拒单类型的，不允许查看现场。-->
								<!--无论什么权限，已撤单的都不允许查看现场-->
								<a @click="locate(fileInfo.id)" v-if="!((fileInfo.rescueStage==51 || fileInfo.rescueStage==52 || fileInfo.rescueStage==53)&&levv==3) && fileInfo.rescueStatus != 4 && permission.indexOf('rescueServiceOrderList_site') == -1">&nbsp;现场</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!--分页组件开始-->
		<pagination v-if="orderList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>
</template>
<script>
	import {DICTIONARY_MAP} from 'static/constant'
	import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import {deepCopy} from 'util/util'
	import {mapState} from 'vuex'
	import classlist from 'util/classlist'
	import { maxLength } from 'vuelidate/lib/validators'
	import MultiSelectTree from 'components/common/MultiSelectTree'
	export default {
	  name: 'PageRescueServiceOrderList',
	  components: {
	    Pagination,
	    Datepicker,
	    TabModal,
	    MultiSelectTree
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['rescueServiceOrderLi'] ? this.$store.state.permission.permission['rescueServiceOrderLi'] : [],
	      loadingstatus: false,
	      showSubPage: false,
	      pageInfo: {},	                                        // 分页所需信息
	      orderList: [], 		                                    // 表格数据列表
	      messageStr: '',					                        // 弹出框内容
	      scrollTop: '',
	      queryParam: {
	        policyNo: '',
	        dateType: '',										// 时间类型
	        rescuedPlateNumber: '',							// 被救援人车牌
	        rescuedPhone: '',							        	// 被救援人电话
	        rescueType: '',		                                // 救援类型
	        id: '',		                            		// 救援单号
	        rescueStatus: '',		                       		    // 救援状态
	        rescueStage: '',								// 救援阶段
	        customerIds: '',							// 救援公司
	        plateNumber: '',								// 救援车牌
	        page_index: 1, 								    // 当前第几页
	        requestStartTime: '',
	        requestEndTime: '',
	        closingCostStart: '',
	        closingCostEnd: '',
	        timeOutStatus: '',					// 超时阶段
	        evaluateStatus: '',					// 客户评价
        customerServiceEvaluateStatus: '',	// 客服评价
	        certificatesType: '',               // 救援单来源
	        companyAuditStatus: '',
	        piccAuditStatus: '',
			platformAuditStatus:'',
			fallEmpty:''
	      },
	      rescueCompanies: [],
	      rescueStatusList: [],
	      dateTypeList: [],
	      rescueTypeList: [],									// 救援类型列表
	      rescueStageList: [],								// 救援状态列表
	      timeoutStageList: [],							// 救援超时阶段列表
	      token: window.localStorage.getItem('accesstoken'),
	      isShow: false,
	      from: 'rescue',
	      setting: {
	        data: {
		                simpleData: {
		                    enable: true,
		                    idKey: 'id',
	                  pIdKey: 'pId'
		                }
		           },
		           check: {
		           		enable: true,
		           		chkboxType: { 'Y': '', 'N': '' }
		           	},
				    callback: {
				        onCheck: this.onClick
				    }
	      },
	      selectCompanysArr: []
	    }
	  },
	  validations: {
	    queryParam: {
	      id: {
	        maxLength: maxLength(10)
	      }
	    }
	  },
	  watch: {
	    refreshOrder (val) { // 重新刷新表格
	      if (val) {
	        this.resetQueryParams()
	        this.getTableInfo()
	      }
	    },
	    'listParam.uni' (val) { // 根据系统上方快速入口拉取表格数据
	      let status = this.listParam.status
	      let stage = this.listParam.stage
	      let type = this.listParam.type
	      this.queryParam.dateType = type
	      this.queryParam.rescueStatus = status
	      this.queryParam.rescueStage = stage
	      let timeOut = this.listParam.timeout
	      this.queryParam.timeOutStatus = this.listParam.timeout
	      let finishFlag = this.listParam.finishFlag
	      this.queryParam.requestStartTime = finishFlag ? this.getCurDate() : ''
	      this.queryParam.requestEndTime = finishFlag ? this.getCurDate() : ''
	      this.getTableInfo()
	    }
	  },
	  computed: {
	    ...mapState({
	      refreshOrder: state => state.rescue.refreshOrder,
	      levv: state => state.user.levv,
	      listParam: state => state.rescue.listParam
	    }),
			// 起止时间是否合法
	    validDates () {
	      if (this.queryParam.requestStartTime && this.queryParam.requestEndTime) {
	        return this.queryParam.requestStartTime > this.queryParam.requestEndTime
	      } else {
	        return false
	      }
	    },
			// 起止费用是否合法
	    validCost () {
	      if (this.queryParam.closingCostStart && !this.queryParam.closingCostEnd) return !(/^\d+$/g.test(this.queryParam.closingCostStart))
	      if (this.queryParam.closingCostEnd && !this.queryParam.closingCostStart) return !(/^\d+$/g.test(this.queryParam.closingCostEnd))
	      if (this.queryParam.closingCostStart && this.queryParam.closingCostEnd) {
	        if (!(/^\d+$/g.test(this.queryParam.closingCostStart)) || !(/^\d+$/g.test(this.queryParam.closingCostEnd))) {
	          return true
	        } else {
	          return parseInt(this.queryParam.closingCostStart) > parseInt(this.queryParam.closingCostEnd)
	        }
	      }
	      if (!this.queryParam.closingCostStart && !this.queryParam.closingCostEnd) return false
	    }
	  },
	  beforeMount () {
	    let status = this.listParam.status
	    let stage = this.listParam.stage
	    let timeOut = this.listParam.timeout
	    this.queryParam.rescueStatus = status
	    this.queryParam.rescueStage = stage
	    this.queryParam.dateType = this.listParam.type
	    this.queryParam.timeOutStatus = this.listParam.timeout
	    let finishFlag = this.listParam.finishFlag
	    this.queryParam.requestStartTime = finishFlag ? this.getCurDate() : ''
	    this.queryParam.requestEndTime = finishFlag ? this.getCurDate() : ''
	    this.getTableInfo()
	    this.getUdc()
//		this.getRescueCompanies();
	  },
	  beforeDestroy () {
	    this.$store.dispatch('getOrderList', {status: '', stage: '', type: '', uni: new Date().getTime()})
	  },
	  methods: {
	    getCurDate () {
	      let dtCur = new Date()
	      let yearCur = dtCur.getFullYear()
	      let monCur = dtCur.getMonth() + 1
	      let dayCur = dtCur.getDate()
	      let timeCur = yearCur + '-' + (monCur < 10 ? '0' + monCur : monCur) + '-' +
			    (dayCur < 10 ? '0' + dayCur : dayCur)
	      return timeCur
	    },
	    handleError (error) {
	      this.openModalMsg(error)
	    },
			// 查询方法
	    searchInfo () {
      this.queryParam.page_index = 1
	      this.queryParam.customerIds = this.selectCompanysArr.length <= 0 || !this.selectCompanysArr ? '' : this.selectCompanysArr.join(',')
	      this.getTableInfo()
	    },
			// 获取列表信息
	    getTableInfo () {
	      let param = deepCopy(this.queryParam)
	      if (param.requestEndTime == '') {
	        delete param.requestEndTime
	      }
	      if (param.requestStartTime == '') {
	        delete param.requestStartTime
	      }
	      param.id = param.id.replace('RS', '')
	      param.id = param.id.replace('rs', '')
	      this.loadingstatus = true
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders', {params: param, headers: this.token})
					.then(res => {
	  if (res.body.success) {
	    this.loadingstatus = false
	    this.$store.dispatch('refreshOrderList', false)
	    if (!res.body.data) return
	    const resInfo = res.body.data
	    const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
	    this.orderList = resInfo.list
	  } else {
	    this.openModalMsg(res.body.message)
	    this.loadingstatus = false
	  }
	}, res => {
	  this.openModalMsg(res.body.message)
	  this.loadingstatus = false
	})/* .catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				}) */
	    },
			// 重置信息
	    resetQueryParams: function () {
	      this.$refs.startTime.handleClear()
	      this.$refs.endTime.handleClear()
	      this.queryParam = {
	        policyNo: '',
	        dateType: '',										// 时间类型
	        rescuedPlateNumber: '',							// 被救援人车牌
	        rescuedPhone: '',							        	// 被救援人电话
	        rescueType: '',		                                // 救援类型
	        id: '',		                            		// 救援单号
	        rescueStatus: '',		                       		    // 救援状态
	        rescueStage: '',								// 救援阶段
	        customerIds: '',							// 救援公司
	        plateNumber: '',								// 救援车牌
	        page_index: 1, 								    // 当前第几页
	        requestStartTime: '',
	        requestEndTime: '',
	        closingCostStart: '',
	        closingCostEnd: '',
	        timeOutStatus: '',
	        evaluateStatus: '',					// 客户评价
        customerServiceEvaluateStatus: '',	// 客服评价
	        certificatesType: '',
	        piccAuditStatus: '',
	        companyAuditStatus: '',
			fallEmpty:''
      }
      this.$refs.zTree.reSet()
	    },
			// 从分页组件获取页码参数
	    getPageNo (param) {
	      this.queryParam.page_index = param
	      this.getTableInfo()
	    },
			// 点击详情
	    handle (id) {
	      const obj = {
	        name: 'RS' + id + '-救援单详情',
	        id: 'PageRescueServiceOrderEdit',
	        route: '/indexhome/rescueServiceOrderEdit' + id,
	        No: 'rescueServiceOrderEdit' + id,
	        params: {id: id, detailMode: 1}
	      }
	      this.$router.push({path: '/indexhome/rescueServiceOrderEdit' + id, query: obj.params})
	      this.$store.dispatch('addTab', obj)
	    },
	    createNewOrder () { // 新建救援服务单
	      const obj = {
	        name: '新建救援单',
	        id: 'PageRescueServiceOrderEdit',
	        route: '/indexhome/rescueServiceOrderEdit',
	        No: 'rescueServiceOrderEdit',
	        params: {detailMode: 0}
	      }
	      this.$router.push({path: '/indexhome/rescueServiceOrderEdit', query: obj.params})
	      this.$store.dispatch('addTab', obj)
	    },
		    exportOrder () { // 导出救援单
	      if (this.orderList.length == 0) {
        this.openModalMsg('导出内容为空')
        return
      }
	      let param = deepCopy(this.queryParam)
	      param.id = param.id.replace('RS', '')
	      param.id = param.id.replace('rs', '')
	      if (param.requestEndTime == '') {
	        delete param.requestEndTime
	      }
	      if (param.requestStartTime == '') {
	        delete param.requestStartTime
	      }
	      this.loadingstatus = true
		//	console.log(this.levv)
	      let url = this.levv == 3 ? '/rescue-api/orders/car/export' : '/rescue-api/orders/export'
	      this.$http.get(process.env.API_INSURANCE_ROOT + url, {params: param, headers: this.token})
					.then(res => {
	  if (res.body.success) {
	    this.loadingstatus = false
	    if (!res.body.data) return
	    let str = res.body.data
	    var path = process.env.EXPORT_PATH
	    var api = process.env.API_ROOT
	    var fileName = path + api + '/noauth/export?url=' + str
						// 'http://192.168.1.244/noauth/export?url=UkVTQ1VFX09SREVSXzM4M18yMDE3MDkxOTA5MjYzNy54bHN4'
						// var fileName = 'http://192.168.1.87:8888/noauth/export?url=' + str;
	//					var fileName = 'http://c.didigps.com/api/noauth/export?url=' + str;
	    				var elemIF = document.createElement('iframe')
			            elemIF.src = fileName
			            elemIF.style.display = 'none'
			            document.body.appendChild(elemIF)
  } else {
	    this.openModalMsg(res.body.message)
	    this.loadingstatus = false
	  }
	}, res => {
	  this.openModalMsg(res.body.message)
	  this.loadingstatus = false
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
			// 定位
	    locate (id) { // 点击地图
	      this.$store.dispatch('openByTab', 2)
				// 1，跳转到监控平台
	      const obj = {
	        name: '救援服务平台',
	        code: 'vehicleMonitor',
	        id: 'PageVehicleMonitor',
	        route: '/indexhome',
	        No: 'vehicleMonitor'
	      }
	      this.$router.push(obj.route)
	      this.$store.dispatch('addTab', obj)
			// 2,拉取定位信息
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/locating/' + id)
			//	this.$http.get('../../../../static/rescueOrder/rescuelocate2.json')
				.then(res => {
	  const info = {
	    resInfo: res.body.data,
	    uni: new Date().getTime()
	  }
	  this.$store.dispatch('dataFromRescue', info)
	}, res => {
	  this.openModalMsg(res.data.message)
	})
				.catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	})
	    },
			// 消息弹出框相关
	    openModal (ref) {
            	this.$refs[ref].open()
            	classlist.toggleScroll('close', '#rescueserviceorder-list', this)
        	},
        	closeModal (ref) {
        		this.$refs[ref].close()
        		classlist.toggleScroll('open', '#rescueserviceorder-list', this)
        	},
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        	},
        	openModalMsg (message) {
        		this.messageStr = message
        		this.openModal('modalMsg')
        	},
        	getUdc () {
	          let udcType = ['RESCUE_TYPE', 'RESCUE_STATUS', 'RESCUE_STAGE', 'DATE_TYPE', 'TIME_OUT_STAGE']
	          let param = udcType.join(',')
	          this.$http.get(process.env.API_ROOT + '/system/udcs/license/2', {params: {udcTypes: param}, headers: this.token})
				.then(res => {
	  if (res.body.success) {
	    let obj = res.body.data
	    this.rescueStatusList = obj.RESCUE_STATUS
	    this.rescueStatusList.unshift({
	      udccode: '',
	      udcname: '全部'
	    })
					 	this.rescueTypeList = obj.RESCUE_TYPE
				 	this.rescueTypeList.unshift({
	   udccode: '',
	   udcname: '全部'
	 })
	    let stageList = [].concat(obj.RESCUE_STAGE)
	    let tmpArr = {}
	    let len = stageList.length
	    for (let i = 0; i < len; i++) {
	      tmpArr[stageList[i].udccode] = i
	    }
	    let stageCodeNeed = [11, 12, 13, 21, 23, 31, 32, 41, 42, 43, 51, 52, 53, 65]
	    stageCodeNeed.map(item => {
	      if (tmpArr[item]) {
	        this.rescueStageList.push(stageList[tmpArr[item]])
	      }
	    })
					 	this.rescueStageList.unshift({
	   udccode: '',
	   udcname: '全部'
	 })
	    this.timeoutStageList = obj.TIME_OUT_STAGE
	    this.timeoutStageList.unshift({
	      udccode: '',
	      udcname: '全部'
	    })
	    this.dateTypeList = obj.DATE_TYPE
	    this.dateTypeList.unshift({
	      udccode: '',
	      udcname: '全部'
	    })
	  } else {
	    this.openModalMsg(res.body.message)
	  }
	}, res => {
	  if (res.body.message == '') {
	    this.openModalMsg('请求出问题啦')
	    return
  }
	  this.openModalMsg(res.body.message)
	})
	        },
	    getRescueCompanies () { // 获取救援公司数据
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/fleet')
				.then(res => {
	  if (res.body.data.length == 0) {
	    this.openModalMsg('救援公司数据为空')
	    return
  }
	  this.rescueCompanies = res.body.data
	}, res => {
	  if (res.body.message == '') {
	    this.openModalMsg('请求出问题啦')
	    return
  }
	  this.openModalMsg(res.body.message)
	})
	    }
	  }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PageRescueServiceOrderList.vue?27558d8a